import React from "react";
import Top from "./Top";
import PublicLayout from "components/Layout/Public";
import RegisterLeftSide from "./RegisterLeftSide";
import { Stack } from "@mui/material";

export default function Container({ children, intl }) {
  return (
    <PublicLayout background={<RegisterLeftSide intl={intl} />}>
      <Stack>
        <Top intl={intl} />
        {children}
      </Stack>
    </PublicLayout>
  );
}
